<template>
  <div>
    <label class="section-title -mt-large -mb">Responses:</label>
    <div v-for="(response, index) in editableResponses" :key="index">
      <input v-model="response.message" type="text" @input="change" />
      <span v-if="responseError(index)" class="alert -inline -danger">Response {{ responseError(index) }}</span>
      <a href="#" class="button -danger -small" @click.prevent="removeResponse(response)">Remove</a>
      <hr />
    </div>

    <a href="#" class="button -small -mb" @click.prevent="addResponse">Add response</a>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

export default {
  name: "QueryResponses",

  props: {
    query: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editableResponses: [],
      editableErrors: []
    };
  },

  watch: {
    query: {
      handler(newQuery, oldQuery) {
        // Only reset if loading different query (by ID change)
        if (!oldQuery || oldQuery.id !== newQuery.id) {
          this.setEditableResponses();
          // Emit the newly loaded responses to parent
          this.$emit("update-responses", JSON.parse(JSON.stringify(this.editableResponses)));
        }
      },
      deep: true
    },

    errors() {
      this.editableErrors = this.errors;
    }
  },

  mounted() {
    this.setEditableResponses();
    // Emit initial responses as a copy to parent
    this.$emit("update-responses", JSON.parse(JSON.stringify(this.editableResponses)));
  },

  methods: {
    responseError(index) {
      return dig(this.editableErrors, this.type, "responses", index, "message", 0);
    },

    addResponse() {
      this.editableResponses.push({ message: "" });
      this.change();
    },

    removeResponse(response) {
      this.editableResponses = _.without(this.editableResponses, response);
      this.change();
    },

    change() {
      this.editableErrors = {};
      const dataToemit = JSON.parse(JSON.stringify(this.editableResponses));
      console.log(`[${this.type}] update-responses emitting:`, dataToemit);
      // Use a different event name to avoid conflict with form's @change
      this.$emit("update-responses", dataToemit);
    },

    setEditableResponses() {
      const responses = dig(this.query, this.type, "responses") || [];
      this.editableResponses = JSON.parse(JSON.stringify(responses));
      console.log(`[${this.type}] setEditableResponses:`, responses, this.editableResponses);
    }
  }
};
</script>
